import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import AmcAns from './shared/AmcAns'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
export default class Head extends Component {
	state = { country: '', region: '' };
	selectCountry (val) {
		global.setValid(true)
		this.setState({ country: val });
		global.setAnswer('CountryWhereYouCurrentlyLive', val, true);
	}
	render() {
		const {t,l} = this.props
		const { country } = this.state;

		return <Q q="Country where you currently live?" {...this.props}>
			<div style={{
				position:"absolute",
				top:200,
				left:60
			}}>
				<CountryDropdown
				value={country}
				onChange={(val) => this.selectCountry(val)} />
			</div>
			
		</Q>	
	}
}



// WEBPACK FOOTER //
// ./src/dComp/CountryWhereYouCurrentlyLive.js